const getFocusableElements = (parentRef: any): Array<HTMLElement> => {
    const focusableElementsString =
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'

    const focusableElements = parentRef.current
        ? parentRef.current.querySelectorAll(focusableElementsString)
        : []

    return Array.prototype.slice.call(focusableElements)
}

export const trapTabKey = (parentRef: any) => (e: KeyboardEvent) => {
    if (e.key === 'tab' || e.keyCode === 9) {
        const focusableElements = getFocusableElements(parentRef)

        if (focusableElements.length > 0) {
            const firstTabStop = focusableElements[0]
            const lastTabStop = focusableElements[focusableElements.length - 1]

            // SHIFT + TAB
            if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                    e.preventDefault()
                    lastTabStop.focus()
                }

                // TAB
            } else if (document.activeElement === lastTabStop) {
                e.preventDefault()
                firstTabStop.focus()
            }
        }
    }
}
